define(["!!../../node_modules/babel-loader/lib/index.js??ref--19!../../node_modules/source-map-loader/dist/cjs.js!./base64Encoder.js"], function (Module) {
            Module = Module.__esModule ? Module.default : Module;

            var instance = new Module();
            
            if (instance.init)
                instance.init();

            return instance;
        });